import { Component, OnInit, ViewChild } from '@angular/core';
import { ProcesoReporte } from '../../base/proceso-reporte';
import { AppComponent } from 'src/app/app.component';
import { Router } from '@angular/router';
import { HomeService } from 'src/app/services/home.service';
import { MessageService } from 'primeng/api';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { SeguridadService } from 'src/app/services/seguridad.service';
import { Acreditacion } from 'src/app/models/administracion/acreditacion.model';
import { Global } from 'src/global';
import { AcreditacionService } from 'src/app/services/administracion/acreditacion.service';
import { Usuario } from 'src/app/models/seguridad/usuario.model';
import { GrupoAccesoRegistro } from 'src/app/models/seguridad/grupo_acceso.model';
import { Cobro } from 'src/app/models/cobranza/cobro.model';
import { EmpresaService } from 'src/app/services/administracion/empresa.service';
import { Empresa } from 'src/app/models/administracion/empresa.model';
import { TreeTable } from 'primeng/treetable';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrl: './dashboard.component.scss',
})
export class DashboardComponent extends ProcesoReporte implements OnInit {
    TIPO_ADMINISTRADOR = Usuario.TIPO_ADMINISTRADOR;

    idInterval: any;

    isMobileView: boolean;
    opcionesBarra: any[] = [
        { name: 'Dia', code: 1 },
        { name: 'Mes', code: 2 },
    ];
    DIA = 1;
    MES = 2;
    opcionSeleccionada: any = this.MES;
    qtyTrxDia: number = 0;
    montoDia: number = 0;
    dateDesde: Date = new Date();
    dateHasta: Date = new Date();
    fromDate: Date = new Date();
    toDate: Date = new Date();
    ordersChart: any;
    ordersOptions: any;
    labels: string[];
    limitePospago: Record<string, any>[];
    limitePrepago: Record<string, any>[];
    acreditacionPospago: Record<string, any>[];
    acreditacionPrepago: Record<string, any>[];
    tipo_creditos = [
        { valor: 1, nombre: 'POSPAGO' },
        { valor: 2, nombre: 'PREPAGO' },
    ];
    POSPAGO = 1;
    PREPAGO = 2;
    PORTAL_PAGOS = 1;
    ACREDITACIONES = 2;
    ARQUEO_CAJA = 3;
    COBROS = 4;
    totalPospago: number;
    totalPrepago: number;
    totalAcreditacionPospago: number;
    totalAcreditacionPrepago: number;
    credito: number;
    acreditacion: number;
    @ViewChild('dt', { static: false }) dt!: any;
    @ViewChild('dt1', { static: false }) dt1!: TreeTable;
    tarjetas: Record<string, any> = {
        importeCobrado: { cobrado: 0, cobro_mes: 0, transaciones: 0 },
        comisionGenerada: { comision_servicio: 0, comision_servicio_mes: 0 },
        comisionAPagar: { comision_boca: 0, comision_boca_mes: 0 },
        comisionNeta: { comision: 0, comision_mes: 0 },
    };
    transacciones: number;
    totalCobro: number;
    empresaSeleccionada: Record<string, any> = {};
    sucursalSeleccionada: Record<string, any> = {};
    //PERMISOS
    permiso_administrador: boolean;
    permiso_empresa: boolean;
    permiso_sucursal: boolean;
    permiso_boca: boolean;
    filtro_admin: boolean;
    filtro_empresa: boolean;
    filtro_sucursal: boolean;
    filtro_boca: boolean;

    contieneLimitePrepago: boolean;
    contieneLimitePospago: boolean;
    contieneAcreditacionPrepago: boolean;
    contieneAcreditacionPospago: boolean;
    iniciandoPortal: boolean = false;

    empresaAutogestion: Record<string, any>;
    id_admin = null;

    constructor(
        public app: AppComponent,
        private router: Router,
        private homeService: HomeService,
        private messageService: MessageService,
        private datePipe: DatePipe,
        private currencyPipe: CurrencyPipe,
        private seguridadService: SeguridadService,
        private empresaService: EmpresaService,
        private acreditacionService: AcreditacionService,
        public appMain: AppComponent
    ) {
        super();
        this.isMobileView = false;
        this.totalPospago = 0;
        this.totalPrepago = 0;
        this.totalAcreditacionPospago = 0;
        this.credito = this.POSPAGO;
        this.acreditacion = this.POSPAGO;
        this.transacciones = 0;
        this.totalCobro = 0;
        this.permiso_administrador = false;
        this.permiso_empresa = false;
        this.permiso_sucursal = false;
        this.permiso_boca = false;
        this.limitePospago = [];
        this.limitePrepago = [];
    }

    ngOnInit(): void {
        this.initComponent();
        this.detectDevice();
    }

    ngOnDestroy(): void {
        if (this.idInterval) {
            clearInterval(this.idInterval);
        }
    }

    async getEmpresaAutogestion() {
        if (this.currentUser?.empresa?.autogestion) {
            const resp = await this.empresaService.get(
                this.currentUser?.empresa?.id
            );
            if (resp.ok) {
                this.empresaAutogestion = resp.resp;
            }
        }
    }

    async initComponent() {
        const date = new Date();
        this.fromDate.setDate(date.getDate() - 30);
        this.dateDesde.setDate(date.getDate() - 180);

        this.id_admin =
            (await this.getIdAdmin()) ?? this.currentUser?.empresa?.id_admin;

        await this.gestionarPermisos();
        await this.recuperarDatos();

        if (this.idInterval) {
            clearInterval(this.idInterval);
        }
        this.idInterval = setInterval(() => {
            this.recuperarDatos();
        }, 30 * 10000);
    }

    private async recuperarDatos() {
        await Promise.all([
            this.getEmpresaAutogestion(),
            this.infoTarjetas(),
            this.getDataBar(),
            this.consumoLimite(),
            this.ultimaAcreditacion(),
        ]);
    }

    detectDevice(): void {
        const userAgent = window.navigator.userAgent.toLowerCase();
        this.isMobileView =
            userAgent.includes('mobile') || userAgent.includes('tablet');
    }

    async filterDataPospago(event: any, blur?: boolean) {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.dt.filterGlobal(event.target.value, 'contains');
        }
    }

    async filterDataPrepago(event: any) {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.dt1.filterGlobal(event.target.value, 'contains');
        }
    }

    async filterDataPrepagoField(event: any, field: string) {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.dt1.filter(event.target.value, field, 'contains');
        }
    }

    async buscar() {
        await this.getDataBar();
        await this.ultimaAcreditacion();
        await this.consumoLimite();
    }

    async gestionarPermisos() {
        const acceso_cobro = await this.seguridadService.tipoAcceso(
            Cobro.CODIGO_MODULO,
            Cobro.CODIGO_REGISTRO
        );
        const acceso_acreditacion = await this.seguridadService.tipoAcceso(
            Acreditacion.CODIGO_MODULO,
            Acreditacion.CODIGO_REGISTRO
        );
        switch (acceso_cobro) {
            case GrupoAccesoRegistro.ACCESO_TODO:
                this.filtro_admin = true;
                break;
            case GrupoAccesoRegistro.ACCESO_EMPRESA:
                this.filtro_empresa = true;
                break;
            case GrupoAccesoRegistro.ACCESO_SUCURSAL:
                this.filtro_sucursal = true;
                break;
            case GrupoAccesoRegistro.ACCESO_USUARIO:
                this.filtro_boca = true;
                break;
        }
        switch (acceso_acreditacion) {
            case GrupoAccesoRegistro.ACCESO_TODO:
                this.filtro_admin = true;
                break;
            case GrupoAccesoRegistro.ACCESO_EMPRESA:
                this.filtro_empresa = true;
                break;
            case GrupoAccesoRegistro.ACCESO_SUCURSAL:
                this.filtro_sucursal = true;
                break;
            case GrupoAccesoRegistro.ACCESO_USUARIO:
                this.filtro_boca = true;
                break;
        }

        switch (this.currentUser.tipo) {
            case Usuario.TIPO_EMPRESA:
                this.permiso_empresa = true;
                break;
            case Usuario.TIPO_SUCURSAL:
                this.permiso_sucursal = true;
                break;
            case Usuario.TIPO_BOCA:
                this.permiso_boca = true;
                break;
            case Usuario.TIPO_ADMINISTRADOR:
                this.permiso_administrador = true;
        }
    }

    async accesosDirectos(tipo: number) {
        switch (tipo) {
            case this.PORTAL_PAGOS:
                this.router.navigate(['pages', 'home', 'portal']);
                break;
            case this.ACREDITACIONES:
                this.router.navigate([
                    'pages',
                    Global.MENU.administracion.routerLink,
                    Global.MENU.administracion.registros.acreditacion
                        .routerLink,
                ]);
                break;
            case this.ARQUEO_CAJA:
                this.router.navigate([
                    'pages',
                    Global.MENU.cobranza.routerLink,
                    Global.MENU.cobranza.registros.arqueo_caja.routerLink,
                ]);
                break;
            case this.COBROS:
                this.router.navigate([
                    'pages',
                    Global.MENU.cobranza.routerLink,
                    Global.MENU.cobranza.registros.cobro.routerLink,
                ]);
                break;
        }
    }

    async onChangeBarra(ev: any) {
        const value = ev.value;
        if (value) {
            this.opcionSeleccionada = value;
            await this.buscar();
        }
    }

    async limpiarFiltro() {
        const date = new Date();
        this.dateDesde = date;
        this.dateHasta = new Date();
        this.dateDesde.setDate(date.getDate() - 180);
        this.fromDate = new Date();
        this.fromDate.setDate(date.getDate() - 30);
        this.toDate = new Date();
        this.empresaSeleccionada = {};
        this.sucursalSeleccionada = {};
        await this.getDataBar();
    }

    async tipoCredito(event: any) {
        const value = event.value;
        if (value) {
            this.credito = value;
        }
    }

    async tipoAcreditacion(event: any) {
        const value = event.value;
        if (value) {
            this.acreditacion = value;
        }
    }

    getTipo(item: number): string {
        switch (item) {
            case 1:
                return 'ADMINISTRACION';
            case 2:
                return 'DEPOSITO';
            case 3:
                return 'TRANSFERENCIA';
            default:
                return '';
        }
    }
    getEstado(estado: boolean): string {
        return estado ? 'Aprobado' : 'Pendiente';
    }

    getSeverity(
        tipo: number
    ): 'success' | 'info' | 'warning' | 'danger' | null | undefined {
        switch (tipo) {
            case 1:
                return 'success';
            case 2:
                return 'info';
            case 3:
                return null;
            default:
                return null;
        }
    }

    async ultimaAcreditacion() {
        try {
            if (!this.permiso_boca) {
                let id_admin = this.id_admin;
                if (!this.id_admin && !this.currentUser?.super) {
                    id_admin = this.currentUser?.empresa?.id_admin;
                }
                const filtros = {
                    id_empresa: this.filtro_empresa
                        ? this.currentUser.id_empresa
                        : null,
                    id_sucursal: this.filtro_sucursal
                        ? this.currentUser.id_sucursal
                        : null,
                    id_creado_por: this.filtro_boca
                        ? this.currentUser.id
                        : null,
                    id_admin: id_admin,
                };
                if (this.filtro_admin) {
                    filtros.id_empresa = null;
                    filtros.id_sucursal = null;
                    filtros.id_creado_por = null;
                }
                if (this.filtro_sucursal) {
                    filtros.id_empresa = this.currentUser.id_empresa;
                }
                const acreditaciones =
                    await this.homeService.ultimasAcreditaciones(filtros);
                if (acreditaciones.ok) {
                    this.acreditacionPospago = acreditaciones.resp.pospago;
                    this.acreditacionPrepago = acreditaciones.resp.prepago;
                    this.totalAcreditacionPrepago =
                        this.acreditacionPrepago?.length;
                    this.totalAcreditacionPospago =
                        this.acreditacionPospago?.length;
                }
                if (this.acreditacionPrepago.length > 0) {
                    this.contieneAcreditacionPrepago = true;
                    this.acreditacion = this.PREPAGO;
                }
                if (this.acreditacionPospago.length > 0) {
                    this.contieneAcreditacionPospago = true;
                    this.acreditacion = this.POSPAGO;
                }
                if (this.filtro_admin) {
                    this.contieneAcreditacionPospago = true;
                    this.contieneAcreditacionPrepago = true;
                }
            }
        } catch (error) {}
    }

    async consumoLimite() {
        try {
            let id_admin = this.id_admin;
            if (!this.id_admin && !this.currentUser?.super) {
                id_admin = this.currentUser?.empresa?.id_admin;
            }
            const filtros = {
                id_empresa: this.filtro_empresa
                    ? this.currentUser.id_empresa
                    : null,
                id_sucursal: this.filtro_sucursal
                    ? this.currentUser.id_sucursal
                    : null,
                id_creado_por: this.filtro_boca ? this.currentUser.id : null,
                id_admin: id_admin,
            };
            if (this.filtro_admin) {
                filtros.id_empresa = null;
                filtros.id_sucursal = null;
                filtros.id_creado_por = null;
            }
            if (this.filtro_sucursal) {
                filtros.id_empresa = this.currentUser.id_empresa;
            }
            if (this.filtro_boca) {
                filtros.id_empresa = this.currentUser.id_empresa;
                filtros.id_sucursal = this.currentUser.id_sucursal;
            }

            const empresas = await this.homeService.consumoLimite(filtros);
            // console.log(empresas);

            if (empresas.ok) {
                await this.procesarPrepago(empresas.resp.prepago);
                await this.procesarPospago(empresas.resp.pospago);
            }

            await this.actualizarEstadoFinal();
        } catch (error) {
            console.error('Error en consumoLimite:', error);
        }
    }

    // Procesar datos PREPAGO
    private async procesarPrepago(prepago: any[]) {
        if (!prepago.length) return;
        if (this.filtro_sucursal) {
            this.limitePrepago = await this.extraerSucursales(
                prepago,
                this.permiso_administrador
            );
        } else {
            this.limitePrepago = await this.animarEmpresas(prepago);
        }
        if (this.filtro_boca && this.limitePrepago[0]?.tipo === 2) {
            this.limitePrepago = await this.filtrarSucursales(
                this.limitePrepago
            );
        }

        this.totalPrepago = this.limitePrepago?.length || 0;
    }

    // Procesar datos POSPAGO
    private async procesarPospago(pospago: any[]) {
        if (!pospago.length) return;
        if (this.filtro_sucursal) {
            this.limitePospago = await this.extraerSucursales(
                pospago,
                this.permiso_administrador
            );
        } else {
            this.limitePospago = await this.animarEmpresas(pospago);
        }

        if (this.filtro_boca && this.limitePospago[0]?.tipo === 2) {
            this.limitePospago = await this.filtrarSucursales(
                this.limitePospago
            );
        }

        this.totalPospago = this.limitePospago?.length || 0;
    }

    // Actualizar estados finales según los resultados
    private async actualizarEstadoFinal() {
        if (this.limitePrepago?.length > 0) {
            this.contieneLimitePrepago = true;
            this.credito = this.PREPAGO;
        }

        if (this.limitePospago?.length > 0) {
            this.contieneLimitePospago = true;
            this.credito = this.POSPAGO;
        }
    }

    // Extraer sucursales (administrador o usuario específico)
    private async extraerSucursales(empresas: any[], admin: boolean = false) {
        const sucursalesPromesas = empresas.map(async (empresa: any) => {
            let sucursales = [];
            if (empresa.tipo === Empresa.TIPO_SUCURSAL) {
                sucursales = empresa.sucursales || [];
                return admin
                    ? await this.animarSucursales(sucursales)
                    : await this.animarSucursales(
                          sucursales.filter(
                              (s: any) => s.id === this.currentUser.id_sucursal
                          )
                      );
            } else {
                sucursales = empresas.filter(
                    (s: any) => s.id === this.currentUser.id_empresa
                );
                return await this.animarSucursales(sucursales);
            }
        });

        const resultados = await Promise.all(sucursalesPromesas);
        return resultados.flat(); // Aplanar el array para obtener todas las sucursales en un solo nivel
    }

    // Animar empresas y sus sucursales
    private async animarEmpresas(empresas: any[]) {
        const empresasPromesas = empresas.map(async (empresa: any) => {
            if (empresa.sucursales) {
                empresa.sucursales = await this.animarSucursales(
                    empresa.sucursales
                );
            }
            const empresaClone = { ...empresa, procesoAnimado: 0 };
            this.animateKnob(empresaClone);
            return empresaClone;
        });
        const resultados = await Promise.all(empresasPromesas);
        return resultados.flat();
    }

    // Animar sucursales
    private async animarSucursales(sucursales: any[]) {
        const animadas = await Promise.all(
            sucursales.map(async (sucursal: any) => {
                const sucursalClone = { ...sucursal, procesoAnimado: 0 };
                await this.animateKnob(sucursalClone);
                return sucursalClone;
            })
        );
        return animadas;
    }

    // Filtrar sucursales por id específico
    private async filtrarSucursales(empresas: any[]) {
        return empresas
            .map((empresa: any) => {
                const sucursal = empresa.sucursales?.find(
                    (s: any) => s.id === this.currentUser.id_sucursal
                );
                return sucursal || null;
            })
            .filter(Boolean);
    }

    private async animateKnob(empresa: any) {
        const target = empresa.porc_utilizado || 0; // Asegura que 'proceso' es un número válido
        const increment = Math.max(target / 100, 0.1); // Incremento mínimo para evitar animaciones muy lentas
        let current = 0;

        const interval = setInterval(() => {
            if (current < target) {
                current = Math.min(current + increment, target); // Evita que 'current' supere 'target'
                empresa.procesoAnimado = parseFloat(current.toFixed(1)); // Redondea a 1 decimal
            } else {
                empresa.procesoAnimado = target; // Asegura que el valor final es exacto
                clearInterval(interval);
            }
        }, 10);
    }

    async buscarAcreditacion(item: Record<string, any>) {
        try {
            this.acreditacionService.obj = item;
            setTimeout(() => {
                this.router.navigate([
                    'pages',
                    Acreditacion.CODIGO_MODULO,
                    Global.MENU.administracion.registros.acreditacion
                        .routerLink,
                    `${item.id}`,
                ]);
            }, 500);
        } catch (error: any) {
            console.log(error);
            this.messageService.add({
                severity: 'Error',
                summary: 'Error',
                detail: error?.message,
            });
        }
    }

    async infoTarjetas() {
        try {
            let fecha_desde = new Date();
            let fecha_hasta = new Date();
            const filtros = {
                fecha_desde: this.datePipe.transform(fecha_desde, 'yyyy-MM-dd'),
                fecha_hasta: this.datePipe.transform(fecha_hasta, 'yyyy-MM-dd'),
                id_empresa: !this.permiso_administrador
                    ? this.currentUser.id_empresa
                    : null,
                id_admin: this.id_admin,
            };
            const infoTarjetas = await this.homeService.infoTarjetas(filtros);
            if (infoTarjetas.ok) {
                this.tarjetas = infoTarjetas.resp;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async filtrarEmpresa(body: Record<string, any>) {
        if (this.filtro_sucursal) {
            this.sucursalSeleccionada = { id_sucursal: body.id };
        }

        this.empresaSeleccionada = {
            id_empresa: body.id,
            nombre_empresa: body.nombre,
        };

        await this.getDataBar();
    }

    async getDataBar() {
        try {
            const textColor =
                getComputedStyle(document.body).getPropertyValue(
                    '--text-color'
                ) || 'rgba(0, 0, 0, 0.87)';
            const gridLinesColor =
                getComputedStyle(document.body).getPropertyValue(
                    '--divider-color'
                ) || 'rgba(160, 167, 181, .3)';
            const fontFamily = getComputedStyle(document.body).getPropertyValue(
                '--font-family'
            );
            let fecha_desde;
            let fecha_hasta;
            if (this.opcionSeleccionada === this.DIA) {
                fecha_desde = this.fromDate;
                fecha_hasta = this.toDate;
            } else {
                fecha_desde = new Date(
                    this.dateDesde.getFullYear(),
                    this.dateDesde.getMonth(),
                    1
                );
                fecha_hasta = new Date(
                    this.dateHasta.getFullYear(),
                    this.dateHasta.getMonth() + 1,
                    0
                );
            }
            const filtros = {
                fecha_desde: this.datePipe.transform(fecha_desde, 'yyyy-MM-dd'),
                fecha_hasta: this.datePipe.transform(fecha_hasta, 'yyyy-MM-dd'),
                tipo: this.opcionSeleccionada,
                id_empresa: this.empresaSeleccionada
                    ? this.empresaSeleccionada.id_empresa
                    : null,
                id_sucursal: null,
                id_creado_por: null,
                id_admin: this.id_admin,
            };

            if (this.filtro_sucursal) {
                filtros.id_empresa = this.currentUser.id_empresa;
                filtros.id_sucursal = this.sucursalSeleccionada.id_sucursal;
            }
            if (this.filtro_boca) {
                filtros.id_creado_por = this.currentUser.id;
            }
            if (!this.permiso_administrador) {
                filtros.id_empresa = this.currentUser.id_empresa;
            }
            const resp = await this.homeService.getMontoCobro(filtros);
            if (resp.ok) {
                const datosFiltrados = resp.resp.montoCobro;
                this.transacciones = resp.resp.montoCobroTotal.cant_cobros;
                this.totalCobro = resp.resp.montoCobroTotal.cobrado;
                this.qtyTrxDia = 0;
                this.montoDia = 0;
                let maxVolumen = 0;
                let maxCobros = 0;
                let dataCobros = [];
                let dataTrx = [];
                let meses = [
                    'Enero',
                    'Febrero',
                    'Marzo',
                    'Abril',
                    'Mayo',
                    'Junio',
                    'Julio',
                    'Agosto',
                    'Setiembre',
                    'Octubre',
                    'Noviembre',
                    'Diciembre',
                ];
                this.labels = [];
                if (this.opcionSeleccionada === this.DIA) {
                    dataCobros = [];
                    dataTrx = [];
                    for (const dato of resp.resp.montoCobro) {
                        this.labels.push(
                            this.datePipe.transform(dato.fecha, 'dd/MM/yyyy')!
                        );
                        dataCobros.push(dato.cobrado);
                        dataTrx.push(dato.cant_cobros);
                        this.qtyTrxDia += Number(dato.cant_cobros);
                        this.montoDia += Number(dato.cobrado);
                        if (dato.cobrado > maxVolumen) {
                            maxVolumen = dato.cobrado;
                        }
                        if (dato.cant_cobros > maxCobros) {
                            maxCobros = dato.cant_cobros;
                        }
                    }
                } else {
                    for (let i = 0; i < datosFiltrados.length; i++) {
                        const matchingDato = datosFiltrados[i];
                        if (
                            matchingDato.cant_cobros > 0 ||
                            matchingDato.cobrado > 0
                        ) {
                            this.labels.push(
                                meses[matchingDato?.mes - 1] +
                                    ' ' +
                                    `${matchingDato?.anho}`
                            );
                            dataCobros.push(matchingDato.cobrado);
                            dataTrx.push(matchingDato.cant_cobros);
                            this.qtyTrxDia += Number(matchingDato.cant_cobros);
                            this.montoDia += Number(matchingDato.cobrado);
                            if (matchingDato.cobrado > maxVolumen) {
                                maxVolumen = matchingDato.cobrado;
                            }
                            if (Number(matchingDato.cant_cobros) > maxCobros) {
                                maxCobros = Number(matchingDato.cant_cobros);
                            }
                        }
                    }
                }
                this.ordersChart = {
                    labels: this.labels,
                    datasets: [
                        {
                            yAxisID: 'y',
                            label: 'Monto Cobrado',
                            type: 'line',
                            data: dataCobros,
                            borderColor: ['rgb(0, 153, 218)'],
                            backgroundColor: ['rgb(0, 153, 218,0.2)'],
                            borderWidth: 2,
                            fill: true,
                            tension: 0.4,
                        },
                        {
                            yAxisID: 'y1',
                            label: 'Cantidad de Transacciones',
                            data: dataTrx,
                            borderColor: [' rgb(233, 111, 0)'],
                            backgroundColor: ['rgb(233, 111, 0,0.7)'],
                            borderWidth: 2,
                            fill: true,
                            tension: 0.4,
                        },
                    ],
                };
                this.ordersOptions = {
                    plugins: {
                        datalabels: {
                            clamp: true,
                            align: 'center',
                            formatter: (value: any, ctx: any) => {
                                return this.currencyPipe.transform(
                                    value,
                                    '',
                                    '',
                                    '0.0-0',
                                    'es-PY'
                                );
                            },
                            color: '#FFFFFF',
                            font: { size: 11, weight: 'bold' },
                        },
                        legend: { labels: { fontFamily, color: textColor } },
                    },
                    responsive: true,
                    scales: {
                        y: {
                            position: 'left',
                            display: true,
                            ticks: { fontFamily, color: textColor },
                            grid: { color: gridLinesColor },
                        },
                        y1: {
                            position: 'right',
                            display: true,
                            ticks: { fontFamily, color: textColor },
                            grid: { display: false },
                        },
                        x: {
                            ticks: { fontFamily, color: textColor },
                            grid: { color: gridLinesColor },
                        },
                    },
                };
            }
        } catch (error: any) {
            console.log(error);
        }
    }

    getProgressColor(progress: number): string {
        if (progress >= 75) {
            return '#f54021'; // Red
        } else if (progress >= 50) {
            return '#f39c12'; // Yellow
        } else {
            return '#2ecc71'; // Green
        }
    }

    isLastNode(rowNode: any): boolean {
        if (!rowNode.parent) {
            return false;
        }

        const siblings = rowNode.parent.children;
        return siblings[siblings.length - 1].data.id === rowNode.node.data.id;
    }

    isFirstNode(rowNode: any): boolean {
        if (!rowNode.parent) {
            return false;
        }

        const siblings = rowNode.parent.children;
        return siblings[0].data.id === rowNode.node.data.id;
    }
}
